import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(createAction('student/DISABLE_MOVED_NEXT_MODULE'));
